import { useNavigate } from "react-router-dom"

const BackButton = ({ className = "", onClick, label }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else if (window.history.state && window.history.state.idx > 0) {
      navigate(-1)
    } else {
      navigate("/select", { replace: true })
    }
  }

  return (
    <button
      onClick={handleClick}
      className={`flex items-center gap-1 p-2 rounded-full text-slate-500 hover:bg-slate-200 hover:text-blue-600 transition-colors ${className}`}
      aria-label="뒤로가기"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2.5}
        stroke="currentColor"
        className="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
        />
      </svg>
      {label && <span className="font-bold text-sm pt-0.5">11{label}</span>}
    </button>
  )
}

export default BackButton
